// src/utils/navigations/useGoHome.js
import { useHistory } from "react-router-dom";

export const useGoHome = () => {
  const history = useHistory();

  const goHome = () => {
    history.replace("/"); // or history.push("/")
  };

  return { goHome };
};